<template>
  <wo-grid v-if="access">
    <wo-column width-md="4" v-for="item in items" :key="item.id">
      <wo-card>
        <po-display :value="item.application" slot="title" />
        <po-action-dropdown :actions="item.actions" @execute="executeAction(item, $event)" slot="actions" />
        <wo-properties mod-horizontal>
          <wo-properties-label><wo-label v-t="'general.status'" /></wo-properties-label>
          <wo-properties-value><po-status-badge :value="item.status" :success="enabledStatus" /></wo-properties-value>
          <template v-if="item.access">
            <wo-properties-label><wo-label v-t="'applicationAccess.owner'" /></wo-properties-label>
            <wo-properties-value><po-display :value="item.access.owner" /></wo-properties-value>
            <template v-if="item.application.branded">
              <wo-properties-label><wo-label v-t="'applicationAccess.brand'" /></wo-properties-label>
              <wo-properties-value><po-display :value="item.access.brand" /></wo-properties-value>
            </template>
          </template>
        </wo-properties>
      </wo-card>
      <wo-spacer />
    </wo-column>
  </wo-grid>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import filtered from '@/mixins/filtered'

import { Company, ApplicationEnum } from '@/model/company'
import { applicationAccessRepository } from '@/repository/company'

import { showConfirmation, showModal } from '@/modal'

import ApplicationAccessCreateModal from '@/components/admin/ApplicationAccessCreateModal'

const ENABLED = { labelKey: 'applicationAccess.enabled' }
const DISABLED = { labelKey: 'applicationAccess.disabled' }

const ENABLE_ACTION = { labelKey: 'general.action.enable', icon: 'lightning' }
const DISABLE_ACTION = { labelKey: 'general.action.disable', icon: 'cross' }

export default {
  mixins: [filtered],
  props: {
    company: Company,
    filter: Object
  },
  computed: mapState({
    access: state => state.company.applicationAccessList,
    items () {
      return _.map(ApplicationEnum.values, this.createItem)
    },
    enabledStatus: () => ENABLED
  }),
  methods: {
    applyFilter (filter, pristine) {
      return this.$store.dispatch(applicationAccessRepository.findAll, { filter: filter, replace: !pristine })
    },
    createItem (application) {
      const item = {
        application: application,
        access: _.find(this.access.items, a => a.application === application)
      }

      item.status = item.access ? ENABLED : DISABLED
      item.actions = [item.access ? DISABLE_ACTION : ENABLE_ACTION]
      return item
    },
    executeAction (item, action) {
      if (action === DISABLE_ACTION) {
        this.disable(item)
      } else if (action === ENABLE_ACTION) {
        this.enable(item)
      }
    },
    disable (item) {
      showConfirmation({ titleKey: item.labelKey, messageKey: 'applicationAccess.confirmDisable' }, () => {
        return this.$store.dispatch(applicationAccessRepository.delete, { entity: item.access })
          .then(this.doFilter)
      })
    },
    enable (item) {
      showModal(ApplicationAccessCreateModal, { company: this.company, application: item.application })
        .then(this.doFilter)
        .catch(e => {})
    }
  }
}
</script>
